import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  configurationSettingDetail,
  configurationSettingUpdate,
} from "reduxStore/action/configurationSettingAction";
import strings from "translate/language";
import { mobileNumberValid, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Button from "../../component/Button";

const ConfigurationMessage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [form, setForm] = useState({});
  const [isModify, setIsModify] = useState(true);
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const configurationSettingDetailSelector =
    useSelector((state) => state?.configurationSettingDetail) || [];
  useEffect(() => {
    dispatch(configurationSettingDetail({ type: "message" }));
  }, []);

  useEffect(() => {
    if (configurationSettingDetailSelector.detail === true) {
      if (configurationSettingDetailSelector?.response?.status === 200) {
        setForm({
          ...form,
          _id: configurationSettingDetailSelector.response.data._id,
          message_account_sid:
            configurationSettingDetailSelector.response.data
              .message_account_sid,
          message_auth_token:
            configurationSettingDetailSelector.response.data.message_auth_token,
          message_account_id:
            configurationSettingDetailSelector.response.data.message_account_id,
          mobile_number:
            configurationSettingDetailSelector.response.data.mobile_number,
        });
      }
    }
  }, [configurationSettingDetailSelector]);

  const handleUpdate = () => {
    if (!handleValid()) {
      const post = {
        setting_id: form._id,
        message_account_sid: form.message_account_sid,
        message_auth_token: form.message_auth_token,
        message_account_id: form.message_account_id,
        mobile_number: form.mobile_number,
      };
      setIsModify(true);
      dispatch(configurationSettingUpdate(post));
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.mobile_number) {
      formError = true;
      err["mobile_number"] = strings.mobileErr;
    } else if (!mobileNumberValid(form.mobile_number)) {
      formError = true;
      err["mobile_number"] = strings.mobileValidErr;
    }
    if (!form.message_account_sid) {
      formError = true;
      err["message_account_sid"] = strings.accountSid_Err;
    }
    if (!form.message_auth_token) {
      formError = true;
      err["message_auth_token"] = strings.authToken_Err;
    }
    if (!form.message_account_id) {
      formError = true;
      err["message_account_id"] = strings.accountId_Err;
    }
    setFormVaild(err);
    return formError;
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  useEffect(() => {
    seo({
      title: "Message",
      metaDescription: "Configuration Message",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.configurationSetting}
        titleactive={strings.configurationMassage}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.configurationMassage}</h5>
              </div>
              <div className="card-body">
                <form>
                  <fieldset disabled={isModify}>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.accountSID}
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            type="text"
                            name="message_account_sid"
                            autoComplete="off"
                            value={form.message_account_sid}
                            onChange={handleInputField}
                          />
                          {formVaild.message_account_sid && (
                            <span style={{ color: "red" }}>
                              {formVaild.message_account_sid}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.authToken}
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            type="text"
                            name="message_auth_token"
                            autoComplete="off"
                            value={form.message_auth_token}
                            onChange={handleInputField}
                          />
                          {formVaild.message_auth_token && (
                            <span style={{ color: "red" }}>
                              {formVaild.message_auth_token}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.accountID}
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            type="text"
                            name="message_account_id"
                            autoComplete="off"
                            value={form.message_account_id}
                            onChange={handleInputField}
                          />
                          {formVaild.message_account_id && (
                            <span style={{ color: "red" }}>
                              {formVaild.message_account_id}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.mobileNo}
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            type="text"
                            name="mobile_number"
                            autoComplete="off"
                            value={form.mobile_number}
                            onChange={handleInputField}
                          />
                          {formVaild.mobile_number && (
                            <span style={{ color: "red" }}>
                              {formVaild.mobile_number}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <Button
                          className="btn btn-color mr-5"
                          onClick={() => setIsModify(!isModify)}
                          label={strings.modify}
                        ></Button>
                        <Button
                          className="btn btn-color"
                          disabled={isModify}
                          onClick={() => handleUpdate()}
                          label={strings.update}
                        ></Button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConfigurationMessage;
